import React from 'react';
import PayeeComponent from '../components/Payee';

const Payee = () => {
  return <PayeeComponent />;
};

export default Payee;
